const loaderScript = document.currentScript;
const triggerSelector = '[data-open-add-to-bag][data-product-url]';

let modalPromise;

async function loadModal() {
  const existingModal = document.getElementById('add-to-bag-modal');
  if (existingModal) return existingModal;
  if (modalPromise) return modalPromise;

  modalPromise = (async () => {
    const sectionUrl = loaderScript?.dataset.sectionUrl;
    const modalModuleUrl = loaderScript?.dataset.modalModuleUrl;
    const sizeGuideModuleUrl = loaderScript?.dataset.sizeGuideModuleUrl;

    if (!sectionUrl || !modalModuleUrl) {
      throw new Error('Add-to-bag modal loader configuration is incomplete.');
    }

    const response = await fetch(sectionUrl, {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    });
    if (!response.ok) {
      throw new Error(`Add-to-bag modal request failed with ${response.status}.`);
    }

    const shell = document.createElement('div');
    shell.setAttribute('data-add-to-bag-modal-shell', '');
    shell.innerHTML = await response.text();
    document.body.appendChild(shell);

    const stylesReady = Promise.all(
      Array.from(shell.querySelectorAll('link[rel="stylesheet"]')).map(
        (link) =>
          new Promise((resolve) => {
            if (link.sheet) return resolve();
            link.addEventListener('load', resolve, { once: true });
            link.addEventListener('error', resolve, { once: true });
          })
      )
    );

    await Promise.all([
      import(modalModuleUrl),
      sizeGuideModuleUrl ? import(sizeGuideModuleUrl) : Promise.resolve(),
      stylesReady,
    ]);
    await customElements.whenDefined('add-to-bag-modal');

    const modal = document.getElementById('add-to-bag-modal');
    if (!modal) throw new Error('Add-to-bag modal was missing from its section response.');
    return modal;
  })().catch((error) => {
    modalPromise = undefined;
    document.querySelector('[data-add-to-bag-modal-shell]')?.remove();
    throw error;
  });

  return modalPromise;
}

async function openFromTrigger(trigger) {
  const productUrl = trigger.dataset.productUrl;
  let modal;

  try {
    modal = await loadModal();
  } catch (error) {
    console.error('[AddToBagModalLoader]', error);
    window.location.assign(productUrl);
    return;
  }

  try {
    await modal.openWithProduct(productUrl);
  } catch (error) {
    console.error('[AddToBagModalLoader]', error);

    // Once the drawer is on screen the shopper asked for the popup, so a failure
    // while filling it must stay in the popup. Navigating here would close the
    // mini cart and dump them on the product page instead.
    if (!modal.querySelector('dialog')?.open) window.location.assign(productUrl);
  }
}

document.addEventListener(
  'click',
  (event) => {
    if (document.getElementById('add-to-bag-modal')) return;

    const trigger = event.target?.closest?.(triggerSelector);
    if (!(trigger instanceof HTMLElement)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    void openFromTrigger(trigger);
  },
  true
);

for (const eventName of ['pointerover', 'focusin', 'touchstart']) {
  document.addEventListener(
    eventName,
    (event) => {
      if (document.getElementById('add-to-bag-modal')) return;
      if (event.target?.closest?.(triggerSelector)) void loadModal().catch(() => {});
    },
    { capture: true, passive: true }
  );
}
